<template>
    <v-row>
      <v-dialog v-model="showDialog" scrollable max-width="750px">
        <v-skeleton-loader
        v-if="loading"
          type="article, actions"
        ></v-skeleton-loader>
        <v-card v-if="!loading">
          <v-card-title>
            <v-panel>
               <span style="font-size: 20px;">
                  {{ !data.id ? $t('wkt.admin.document-category.edit-document-category.edit-title-new') : $t('wkt.admin.document-category.edit-document-category.edit-title-edit' )}}     
               </span>
            </v-panel>
          </v-card-title>
          <v-card-text>
            <v-container>
                          <v-form ref="form">
                              <v-row>
  
                                  <v-col cols="6">                
                                      <v-text-field
                                          v-model="data.name"
                                          :label="$t('wkt.admin.document-category.table.headers.name')"
                                          autocomplete="none"
                                          :rules="[validationRules.required]"
                                          max="200"
                                      />
                                  </v-col>

                                 <v-col cols="6">                
                                      <v-text-field
                                          v-model="data.internalCode"
                                          :label="$t('wkt.admin.document-category.table.headers.internal-code')"
                                          autocomplete="none"
                                          max="400"
                                      />
                                  </v-col>

                                    <v-col cols="12">                
                                      <v-text-field
                                          v-model="data.description"
                                          :label="$t('wkt.admin.document-category.table.headers.description')"
                                          autocomplete="none"
                                          :rules="[validationRules.required]"
                                          max="200"
                                      />
                                  </v-col>
                                  
                           
                              </v-row>
                          </v-form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn v-if="data.id" color="#ff0000" @click="confirmDelete()">
                          <v-icon left color="#ffffff">delete</v-icon>
                          <span style="color: #ffffff;">{{ $t('wkt.admin.common.dialog-buttons.delete').toUpperCase() }}</span>
                      </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="#185EA9" text @click="onSave()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}</v-btn>
            <v-btn text @click="showDialog=false" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> 
  
            <ConfirmDialog ref="dlgConfirm"
              v-bind:title="$t('wkt.admin.document-category.edit-document-category.confirm-dialog.title')"
              v-bind:message="$t('wkt.admin.document-category.edit-document-category.confirm-dialog.text')"
              v-bind:titleOk="$t('wkt.admin.common.dialog-buttons.delete')"
              v-bind:titleCancel="$t('wkt.admin.common.dialog-buttons.cancel')"
              v-on:confirmed="deleteItem()"
          />
    </v-row>	
  </template>
  
<script>
import BaseModule from '../../common/BaseModule.js'
import ConfirmDialog from '../../common/ConfirmDialog'
import api from '../../../api/worktime'
import gwt from '../../../api/gwt'

export default {
   name: 'DocumentCategoryDialog',
   mixins: [BaseModule],
   components: {
      ConfirmDialog
   },
   data() {
      return {
         showDialog: false,
         loading: true,
         data: {}
      }
   },
   methods: {

       // eslint-disable-next-line no-unused-vars
      open: function (action, payload) {

         this.showDialog = true;

         if (this.$refs.form) {
            this.$refs.form.resetValidation();
         }

         if (!payload) { // Estamos creando un elemento
            this.data = {
               companyId: gwt.getSessionProfile().companyId
            };
            this.loading = false; 
            return;
         }

         this.loading = true;
         api.getDocumentCategoryById(payload, res => {
            this.data = res;
            this.loading = false;
         }, error => {
            this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            this.loading = false;
         })


      },
      onSave: function () {
         if (!this.$refs.form.validate()) {
            return;
         }

         this.loading = true;
         // eslint-disable-next-line no-unused-vars
         api.storeDocumentCategory(this.data,res => {
               this.loading = false;
               if (res.rsOK) {
                  this.$emit('refresh');
                  this.showDialog = false;
               } else {
                  this.$emit('show-alert',{ text: res.message, color: 'error', timeout: 3000 });
               }
            },
            error => {
               this.$log.error(error);
               this.loading = false;
               this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            });
      },
      confirmDelete() {
         this.$refs.dlgConfirm.confirm(this.data);
      },
      deleteItem() {
        this.loading = true;
        // eslint-disable-next-line no-unused-vars
         api.deleteDocumentCategory(this.data.id, res => {
               this.showDialog = false;
               this.loading = false;
               this.$emit('refresh');
            },
            (error) => {
               this.loading = false;
               this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            }
         );
      }
   },
}
</script>